import React from 'react';

interface Example {
  company: string;
  headline: string;
  image: string;
}

export function Examples() {
  const examples: Example[] = [
    {
      company: "Spotify",
      headline: "Listen without limits. Try 1 month of Premium Individual for free.",
      image: "https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2Fde98648b58e7b6928c0764989ef42391.cdn.bubble.io%2Ff1728908897427x853830963687973100%2Fspotify.png?w=768&h=512&auto=compress&dpr=2&fit=max"
    },
    {
      company: "Ship Fast by Mark Lau",
      headline: "Ship your startup in days, not weeks",
      image: "https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2Fde98648b58e7b6928c0764989ef42391.cdn.bubble.io%2Ff1728909202188x403801853464237100%2Fshipfast.png?w=768&h=512&auto=compress&dpr=2&fit=max"
    },
    {
      company: "Netflix",
      headline: "Unlimited movies, TV shows, and more",
      image: "https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2Fde98648b58e7b6928c0764989ef42391.cdn.bubble.io%2Ff1728909216937x436643265669288260%2Fnetflix.png?w=768&h=512&auto=compress&dpr=2&fit=max"
    },
    {
      company: "Interior AI by levelsio",
      headline: "Redesign your interior in seconds using AI",
      image: "https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2Fde98648b58e7b6928c0764989ef42391.cdn.bubble.io%2Ff1728909255955x132641975968545760%2Finteriorai.png?w=768&h=512&auto=compress&dpr=2&fit=max"
    }
  ];

  return (
    <section className="py-16 px-4">
      <h2 className="text-2xl font-bold mb-8 text-center">
        How the 4U technique is used by services and solopreneurs:
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
        {examples.map((example) => (
          <div
            key={example.company}
            className="bg-black text-white rounded-xl overflow-hidden"
          >
            <div className="aspect-video relative">
              <img
                src={example.image}
                alt={example.company}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/40"></div>
            </div>
            <div className="p-6">
              <h3 className="font-medium mb-2">{example.company}</h3>
              <p className="text-lg font-bold">{example.headline}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}